import React, { useState } from "react";
import styles from "./Info.module.scss";


const InfoTooltip = ({ paragraphs }) => {
    const [isHovered, setIsHovered] = useState(false);

    if (paragraphs.length < 1 || paragraphs.length > 5) {
        console.error("Paragraphs should be between 1 and 5.");
        return null;
    }

    return (
        <div
            className={styles.infoTooltip}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <span className={styles.infoIcon}>i</span>
            {isHovered && (
                <div className={styles.tooltip}>
                    {paragraphs.map((text, index) => (
                        <p key={index}>{text}</p>
                    ))}
                </div>
            )}
        </div>
    );
};

export default InfoTooltip;
